import { css } from '@emotion/css';

export const BaseStyle = {
  clearFix: css({
    overflow: 'auto',
  }),
  pullLeft: css({
    float: 'left',
  }),
  pullRight: css({
    float: 'right',
  }),
  clip: css({
    overflow: 'hidden',
  }),
  radiusless: css({
    borderRadius: 'none',
  }),
  shadowless: css({
    boxShadow: 'none',
  }),
  unselectable: css({
    userSelect: 'none',
  }),
  clickable: css({
    cursor: 'pointer !important',
  }),
  relative: css({
    position: 'relative',
  }),
  level: css({
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'center !important',
  }),
  levelRight: css({
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'flex-end !important',
  }),
  levelLeft: css({
    display: 'flex !important',
    alignItems: 'center !important',
    justifyContent: 'flex-start !important',
  }),
};

export const BaseLayout = {
  card: css({
    padding: '15px 10px 15px 10px !important',
    boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
    transition: '0.3s',
    borderRadius: '5px',
  }),
  container: css({
    border: '1px solid #e0e0e0',
    borderRadius: '5px',
  }),
};
